import { Button } from "@/components/ui/button";
import {
  Dialog,
  DialogClose,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogTrigger,
} from "@/components/ui/dialog";
import QRCodeWithLogo from "@/components/v-pos/qr-code.component";
import { Loader } from "@/components/v-pos/loader.component";
import { FC } from "react";
import { LuScanQrCode } from "react-icons/lu";
type QRDialogProps = {
  paymentUrl: string;
};

const QRDialog: FC<QRDialogProps> = ({ paymentUrl }) => {
  return (
    <Dialog>
      <DialogTrigger className="flex flex-none justify-center items-center cursor-pointer">
        <LuScanQrCode  className="text-[40px] w-[50px] h-[50px]" color="#444444" />
      </DialogTrigger>
      <DialogContent className="w-[330px] rounded-[6px] p-0">
        <DialogHeader className="rounded-t-[6px] py-4 border-b">
          <DialogTitle className="flex justify-center items-center text-base px-2">
            مشتری می تواند این QR را اسکن کند <br /> و به صفحه پرداخت هدایت شود.
          </DialogTitle>
        </DialogHeader>
        <div className="mx-auto my-7">
          {!paymentUrl ? (
            <div className="flex justify-center items-center">
              <Loader />
            </div>
          ) : (
            <QRCodeWithLogo value={paymentUrl || "scs "} size={260} />
          )}
        </div>
        <DialogClose asChild>
          <div className="w-[calc(100%-30px)] mx-auto">
            <Button className="w-full mb-[20px] rounded-2xl">انـصـراف</Button>
          </div>
        </DialogClose>
      </DialogContent>
    </Dialog>
  );
};

export default QRDialog;
